<template>
<div class="chapter">
<div class="inner_page">
<p class="h2">LIST OF SYMBOLS AND SPECIAL CHARACTERS</p>
<p class="list">( ) in translations inclose elements not in the original but desirable or necessary for a better understanding in English.</p>
<p class="listb">(?) indicate that the meaning is uncertain.</p>
<p class="listb">[ ] inclose restorations in the text.</p>
<p class="listb"><img alt="image" class="sup1" src="img/rec1.jpg"/> <img alt="image" class="sup1" src="img/rec2.jpg"/> inclose a word, a phrase, or a line which is partially damaged.</p>
<p class="listb">. . . . (1) in translations indicate that the text is unintelligible to the translator;</p>
<p class="list1i">(2) in titles of books indicate omission.</p>
<p class="listb">[. . . .] or <img alt="image" class="sup1" src="img/rec1.jpg"/>. . . .<img alt="image" class="sup1" src="img/rec2.jpg"/> indicate that the text is wholly or partially damaged and therefore unintelligible.</p>
<p class="listb"><span class="sans">ˉ</span> <i>or</i> <span class="sans">ˆ</span> indicates a long vowel.</p>
<p class="listb"><span class="sans">˘</span> indicates a short vowel.</p>
<p class="listb"><img alt="image" class="sup1" src="img/int2.jpg"/> = <img alt="image" class="mid" src="img/a1.jpg"/>.</p>
<p class="listb"><img alt="image" class="sup2" src="img/int3.jpg"/> = <img alt="image" class="mid" src="img/a2.jpg"/>.</p>
<p class="listb"><i><img alt="image" class="mid" src="img/int8.jpg"/></i> = <img alt="image" class="mid" src="img/a3.jpg"/>.</p>
<p class="listb"><i><img alt="image" class="mid" src="img/int10.jpg"/></i> = <img alt="image" class="mid" src="img/a4.jpg"/>.</p>
<p class="listb"><i><span class="sans">ṡ</span></i> = <img alt="image" class="mid" src="img/a5.jpg"/>.</p>
<p class="listb"><i><img alt="image" class="mid" src="img/int11a.jpg"/></i> = <img alt="image" class="mid" src="img/a6.jpg"/>.<a id="page_x"></a><a id="page_1"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226112428_09_sym.vue?20388738